import { render } from "./PageA4.vue?vue&type=template&id=41cfae01&scoped=true"
import script from "./PageA4.vue?vue&type=script&lang=js"
export * from "./PageA4.vue?vue&type=script&lang=js"

import "./PageA4.vue?vue&type=style&index=0&id=41cfae01&scoped=true&lang=scss"

import exportComponent from "/srv/http/cv.mzubiaga.net/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41cfae01"]])

export default __exports__